import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Button, Menu, MenuItem } from "components/bootstrap";
import { DropdownMenu } from "security-app/components/common";
import { GLCheckbox } from "common/components";
import { useColumnTogglerContext } from "security-app/components/common/ColumnToggler";
const IconContainer = styled.div`
  width: 16px;
  display: inline-block;
  text-align: left;
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const ColumnList = () => {
  const { cacheId, columns, columnsDispatch } = useColumnTogglerContext();
  const groupedCols = useMemo(
    () => Object.keys(columns).reduce(
      (acc, column) => {
        if (columns[column].group) {
          const { group } = columns[column];
          if (!acc[group]) acc[group] = {};
          acc[group][column] = columns[column];
        } else {
          if (!acc.all) acc.all = {};
          acc.all[column] = columns[column];
        }
        return acc;
      },
      {}
    ),
    [columns]
  );
  const toggleColumn = (key) => () => {
    columnsDispatch({ type: "toggle", payload: { cacheId, column: key } });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Object.keys(groupedCols).sort((a, b) => a.localeCompare(b)).map((group) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `${group}-frag` }, group !== "all" && /* @__PURE__ */ React.createElement(Menu.Label, { key: group }, group), Object.keys(groupedCols[group]).sort((a, b) => a.localeCompare(b)).map((key) => /* @__PURE__ */ React.createElement(MenuItem, { key, onClick: toggleColumn(key), "data-testid": `menuitem-${key}` }, /* @__PURE__ */ React.createElement(Option, null, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: columns[key].visible, onChange: () => {
  }, "data-testid": `checkbox-${key}` }), /* @__PURE__ */ React.createElement("span", null, columns[key].label)))))));
};
function ColumnToggler() {
  return /* @__PURE__ */ React.createElement("div", { style: { float: "left" } }, /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      closeOnItemClick: false,
      trigger: /* @__PURE__ */ React.createElement(Button, { bsSize: "small", "data-testid": "new-btn" }, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down", size: "xs" })), "Columns")
    },
    /* @__PURE__ */ React.createElement(ColumnList, null)
  ));
}
export default ColumnToggler;
